import React from "react";
import { Box, Toolbar } from "@mui/material";
import { Header } from "../components";
import Orderlist from "../features/orderList";
import Cart from "../features/cart";
import OrderComplete from "../features/orderComplete";
import OrderHistory from "../features/orderHistory";
import OrderDetail from "../features/orderDetail";
import Delivery from "../features/delivery";
import { colors } from "../utils/theme";
import { routingPath } from "../utils/path";
import { Routes, Route } from 'react-router-dom';

export default function MainPage() {
  return (
    <>
      <Header/>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flexGrow: 1, bgcolor: colors.backGroundColor, minHeight: '100vh' }}>
          <Toolbar />
          <Routes>
            <Route path={routingPath.orderList} element={<Orderlist />} />
            <Route path={routingPath.cart} element={<Cart />} />
            <Route path={routingPath.orderHistory} element={<OrderHistory />} />
            <Route path={routingPath.orderDetail} element={<OrderDetail />} />
            <Route path={routingPath.delivery} element={<Delivery />} />
            <Route path={routingPath.orderComplete} element={<OrderComplete />} />
          </Routes>
        </Box>
      </Box>
    </>
  );
};
